import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class InputsProductsPrice extends Component{ 

    constructor(props){
      super(props);

      this.state={
          productsprice:[],
          modalTitle:"",
          productpriceid:0,
          yearid: 0,
          productid:0,
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",
		year: {
			yearid:0,
			fyname:"",
			isactive: true
		},
		product: {
			productid:0,
			sapcode: "",
			productdescription: "",
      currencyid: 0,
      devise: {
				currencyid: 0,
				devise: "",
				devisename: ""
			}
		},

          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          ProductIdFilter:"",
          ProductPriceIdFilter:"",
          productspriceWithoutFilter:[],
          fiscalYears: [], 
          productdescriptions: [],
          loading: true,
          isEditClicked: false,
          productsDescriptionsData:[],
          uniqueProductsDescriptions:[],
          fiscalYearsData:[],
          fiscalYearExists:false,
          productDescriptionExists:false,

          palletsvalues:[],
          palletvalueid_o:0,
          yearid_o:0,
		      fyname_o: "",
          productid_o:0,
          sapcode_o:"",
		      productdescription_o: "",
		      july_o: 0,
		      august_o: 0,
		      september_o: 0,
		      october_o: 0,
		      november_o: 0,
		      december_o: 0,
		      january_o: 0,
		      february_o: 0,
		      march_o: 0,
		      april_o: 0,
		      may_o: 0,
		      june_o: 0,
          FiscalYearNameOFilter:"",
          ProductIdOFilter:"",
          ProductDescriptionOFilter:"",
          palletsvaluesWithoutFilter:[],
          SapcodeDupNames:[],
          SapcodeDupDescriptionNames:[],
          SapcodeNames:[],
          SapcodeDescriptionNames:[],

          uniqueRowConcat:[],
          
      }
  }

  FilterFn(){
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var ProductPriceIdFilter = this.state.ProductPriceIdFilter;
    var ProductIdFilter = this.state.ProductIdFilter;

    var filteredData=this.state.productspriceWithoutFilter.filter(
        function(el){
            return  el.year.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.product.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
                el.productpriceid.toString().toLowerCase().includes(
                ProductPriceIdFilter.toString().trim().toLowerCase()
            )&&  
            el.product.sapcode.toString().toLowerCase().includes(
            ProductIdFilter.toString().trim().toLowerCase()
        )
        }
    );

    this.setState({productsprice:filteredData});

}

FilterFnPalletValue(){

  var FiscalYearNameOFilter = this.state.FiscalYearNameOFilter;
  var ProductIdOFilter = this.state.ProductIdOFilter;
  var ProductDescriptionOFilter = this.state.ProductDescriptionOFilter;

  var filteredDataPalletValue=this.state.palletsvaluesWithoutFilter.filter(
    function(el){
        return el.fyname_o?.toString().toLowerCase().includes(
            FiscalYearNameOFilter.toString().trim().toLowerCase()
        )&&  
            el.sapcode_o?.toString().toLowerCase().includes(
            ProductIdOFilter.toString().trim().toLowerCase()
        )&&  
            el.productdescription_o?.toString().toLowerCase().includes(
            ProductDescriptionOFilter.toString().trim().toLowerCase()
        )
    }
);

  this.setState({palletsvalues:filteredDataPalletValue});

}

sortResult(prop,asc){
  var sortedData=this.state.productspriceWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({productsprice:sortedData});

}

sortResultPalletValue(prop,asc){

  var sortedDataPalletValue=this.state.palletsvaluesWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

  this.setState({palletsvalues:sortedDataPalletValue});

}




changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }

  changeProductIdFilter = (e)=>{
    this.state.ProductIdFilter=e.target.value;
    this.FilterFn();
  }


changeProductPriceIdFilter = (e)=>{
    this.state.ProductPriceIdFilter=e.target.value;
    this.FilterFn();
  }

  changeFiscalYearNameOFilter = (e)=>{
    this.state.FiscalYearNameOFilter=e.target.value;
    this.FilterFnPalletValue();
  }
  
  changeProductIdOFilter = (e)=>{
    this.state.ProductIdOFilter=e.target.value;
    this.FilterFnPalletValue();
  }
  
  changeProductDescriptionOFilter = (e)=>{
    this.state.ProductDescriptionOFilter=e.target.value;
    this.FilterFnPalletValue();
  }



  refreshList = () => {
    axiosService.get('/productsprice/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ productsprice: data, productspriceWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  refreshListPalletsValues = () => {
    axiosService.get('/palletsvalues/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ palletsvalues: data, palletsvaluesWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const productdescriptions = filteredData.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }


  fetchSapcodeNames() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const SapcodeNames = filteredData.map(item => item.sapcode);
  
        const sapcodeToProductDescriptionMap = {};
        filteredData.forEach(item => {
          sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        });
  
        this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }
  
  findProductDescriptionForSapcode(sapcode) {
    const productDescriptionMap = this.state.SapcodeDescriptionNames;
    return productDescriptionMap[sapcode] || "Product not found";
  }


  fetchProductDescriptionsData() {
    axiosService.get('/productsprice/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
        const uniqueProductDescriptions = [...new Set(data.map((item) => item.product.productdescription))];
        this.setState({ uniqueProductsDescriptions: uniqueProductDescriptions });
      })
      .catch((error) => {
        console.error('Error fetching products data:', error);
      });
  }

fetchFiscalYearsData() {
    axiosService.get('/productsprice/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const fiscalYearsData= data.map(item => item.year.fyname);
        this.setState({ fiscalYearsData: fiscalYearsData });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchUniqueRowConcat() {
    axiosService.get('/productsprice/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const result = Array.from(new Set(data.map(item => `${item.year.fyname}${item.product.productdescription}`)));
        this.setState({ uniqueRowConcat: result });
      })
      .catch(error => {
        console.error("Error fetching concatList:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };

  checkFsicalYearExists = (event) => {
    const enteredFiscalYear = event.target.value;
    const { fiscalYears } = this.state;
    const fiscalYearExists = fiscalYears.includes(parseInt(enteredFiscalYear));
    this.setState({ fiscalYearExists:fiscalYearExists });
  };

  checkProductDescriptionExists = (event) => {
    const enteredProductDescription = event.target.value.toLowerCase(); // Convert to lowercase
    const { uniqueProductsDescriptions, fiscalYearExists } = this.state;
  
    const productDescriptionExists = uniqueProductsDescriptions.some((productdescription) => productdescription.toLowerCase() === enteredProductDescription);
  
    const finalProductDescriptionExists = fiscalYearExists || productDescriptionExists;
  
    this.setState({ productDescriptionExists: finalProductDescriptionExists });
  };

  


componentDidMount(){
  this.refreshList();
  this.refreshListPalletsValues();
  this.fetchFiscalYears();
  this.fetchProductDescriptions();
  this.fetchProductDescriptionsData();
  this.fetchFiscalYearsData();
  this.fetchSapcodeNames();
  this.fetchUniqueRowConcat();
}



changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeProductDescription =(e)=>{
    this.setState({productdescription:e.target.value});
  }

  changeDevise =(e)=>{
    this.setState({devisename:e.target.value});
  }


changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }

addClick(){
  this.setState({
      modalTitle:"Add ProductPrice",
      productpriceid:0,
      fyname:"",
      productdescription:"",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      isEditClicked: false,
      fiscalYearExists:false,
      productDescriptionExists:false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit ProductPrice",
    productpriceid: dep.productpriceid,
    fyname:dep.year.fyname,
    productdescription:dep.product.productdescription,
    devisename:dep.product.devise.devisename,
    sapcode: dep.product.sapcode,
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    initialFyname:dep.year.fyname,
    initialProductdescription:dep.product.productdescription,
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    isEditClicked: true,
  });
}

createClick() {
  const { fyname, productdescription, july, august, september, october,
  november, december, january, february, march, april, may, june,  fiscalYears, productdescriptions, sapcode, fiscalYearsData, productsDescriptionsData,uniqueProductsDescriptions , uniqueRowConcat} = this.state;


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }
/*
  if (fiscalYearsData.includes(parseInt(fyname)) && uniqueProductsDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase())) {
    alert('This Product already exists for the current Fiscal. Please provide the Fiscal Year or modify the existing record');
    return;
  }
  */

  if (uniqueRowConcat.includes(`${fyname}${productdescription}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
}

  axiosService.post('/productspricecreate/', {
    fyname: fyname,
    productdescription:productdescription,
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june
  })
    .then(result => {
      alert('ProductPrice created');
      this.refreshList();
      window.location.reload();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { fyname, productdescription, july, august, september, october,
    november, december, january, february, march, april, may, june, 
    initialFyname, initialProductdescription, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune, devisename  } = this.state;

  if (
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune
  ) {
    alert('No changes detected');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/productsprice/' + id + '/', {
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    //devisename: this.state.devisename,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}



copyClick() {
  const { fyname, productdescription, july, august, september, october,
    november, december, january, february, march, april, may, june, 
    initialFyname, initialProductdescription, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune, fiscalYearsData, uniqueProductsDescriptions, uniqueRowConcat  } = this.state;

  
  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

/*
  if (fiscalYearsData.includes(parseInt(fyname)) && uniqueProductsDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase())) {
    alert('This Product already exists for the current Fiscal. Please provide the Fiscal Year or modify the existing record');
    return;
  }
  */


  if (uniqueRowConcat.includes(`${fyname}${productdescription}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
}

  
  axiosService.post('/productspricecreate/', {
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('ProductPrice created');
      this.refreshList();
      window.location.reload();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/productsprice/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}




render(){
  const {
      productsprice,
      modalTitle,
      productpriceid,
      fyname,
      productdescription,
      devise,
      devisename,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      fiscalYearExists,
      productDescriptionExists,

      palletsvalues,
      palletvalueid_o,
      yearid_o,
		  fyname_o,
      productid_o,
		  productdescription_o,
      july_o,
      august_o,
      september_o,
      november_o,
      december_o,
      january_o,
      february_o,
      march_o,
      april_o,
      may_o,
      june_o,

  }=this.state;

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsInputs />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add ProductPrice
</button>
<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Product Price
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr  className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>
      </div>
      Product Description
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Devise
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {productsprice.map(dep=>
      <tr key={dep.productpriceid} className="row-hover">
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.devise?.devisename ?? 'N/A'}</td>
          <td className="table-text">{dep.july ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.july) : 'N/A'}</td>
<td className="table-text">{dep.august ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.august) : 'N/A'}</td>
<td className="table-text">{dep.september ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.september) : 'N/A'}</td>
<td className="table-text">{dep.october ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.october) : 'N/A'}</td>
<td className="table-text">{dep.november ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.november) : 'N/A'}</td>
<td className="table-text">{dep.december ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.december) : 'N/A'}</td>
<td className="table-text">{dep.january ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.january) : 'N/A'}</td>
<td className="table-text">{dep.february ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.february) : 'N/A'}</td>
<td className="table-text">{dep.march ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.march) : 'N/A'}</td>
<td className="table-text">{dep.april ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.april) : 'N/A'}</td>
<td className="table-text">{dep.may ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.may) : 'N/A'}</td>
<td className="table-text">{dep.june ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.june) : 'N/A'}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>
          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Pallets Values
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeFiscalYearNameOFilter}
      style={{ width: "70px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeProductIdOFilter}
      style={{ width: "70px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeProductDescriptionOFilter}
      style={{ width: "200px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
      </div>
      Product Description
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>

</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {palletsvalues.map(dep=>
      <tr key={dep.palletvalueid_o} className="row-hover">
          <td className="table-text">{dep.fyname_o}</td>
          <td className="table-text">{dep.sapcode_o}</td>
          <td className="table-text">{dep.productdescription_o}</td>
<td className="table-text">{dep.july_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.july_o) : 'N/A'}</td>
<td className="table-text">{dep.august_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.august_o) : 'N/A'}</td>
<td className="table-text">{dep.september_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.september_o) : 'N/A'}</td>
<td className="table-text">{dep.october_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.october_o) : 'N/A'}</td>
<td className="table-text">{dep.november_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.november_o) : 'N/A'}</td>
<td className="table-text">{dep.december_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.december_o) : 'N/A'}</td>
<td className="table-text">{dep.january_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.january_o) : 'N/A'}</td>
<td className="table-text">{dep.february_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.february_o) : 'N/A'}</td>
<td className="table-text">{dep.march_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.march_o) : 'N/A'}</td>
<td className="table-text">{dep.april_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.april_o) : 'N/A'}</td>
<td className="table-text">{dep.may_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.may_o) : 'N/A'}</td>
<td className="table-text">{dep.june_o ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.june_o) : 'N/A'}</td>


      </tr>
      )}
</tbody>
 )
}
</table>
</div>
<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className={`form-select ${fiscalYearExists ? "is-invalid" : ""}`}
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            onBlur={this.checkFsicalYearExists}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
          
        </div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    type="text"
    className={`form-control ${productDescriptionExists ? "is-invalid" : ""}`}
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    onBlur={this.checkProductDescriptionExists}
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>


<div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Devise</span>
          <input type="text" className="form-control" value={devisename} onChange={this.changeDevise} 
          disabled={this.state.isEditClicked}
          
          style={{ fontSize: "12px" }}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        {productpriceid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {productpriceid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(productpriceid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className={`form-select ${fiscalYearExists ? "is-invalid" : ""}`}
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
        
            onBlur={this.checkFsicalYearExists}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
          
        </div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>



<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    type="text"
    className={`form-control ${productDescriptionExists ? "is-invalid" : ""}`}
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    onBlur={this.checkProductDescriptionExists}
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>


<div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Devise</span>
          <input type="text" className="form-control" value={devisename} onChange={this.changeDevise} 
          disabled={this.state.isEditClicked}
          
          style={{ fontSize: "12px" }}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        {productpriceid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {productpriceid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




